export const LIB_VERSION = '2025.5.0';
